import { useVinDecodeApiV1VehiclesDecodeVinVinGet } from '#/shared/api/generated/shipment/theCargoShipment'
import type { VinDecodeResponse } from '#/shared/api/generated/shipment/models'
import { useDebouncedValue } from '#/shared/lib/hooks'

export type VinDecodeResult = VinDecodeResponse

const VIN_LENGTH = 17
const DEBOUNCE_MS = 250

export function useVinDecode(query: string, options?: { enabled?: boolean }) {
  const normalized = query.trim().toUpperCase()
  const debouncedQuery = useDebouncedValue(normalized, DEBOUNCE_MS)
  const isComplete = debouncedQuery.length === VIN_LENGTH
  const enabled = (options?.enabled ?? true) && isComplete
  const { data, isFetching } = useVinDecodeApiV1VehiclesDecodeVinVinGet(
    debouncedQuery,
    { query: { enabled } },
  )
  const decoded = data?.data
  return { decoded, isLoading: isFetching && enabled }
}
